export default "__VITE_ASSET__DinBkycL__"